function url($url = '') {
    if (window['BASE_URL'])
        return window['BASE_URL'] + '/' + $url.replace(/^\/+(\d+)?/, '')
            .replace(/^\/+/, '');

    return window.location.origin.replace('http://', 'https://') + '/' + $url.replace(/^\/+/, '');
}
class Http {

    static extend() {
        let extended = {};
        let deep = false;
        let i = 0;
        const length = arguments.length;

// Check if a deep merge
        if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
            deep = arguments[0];
            i++;
        }

// Merge the object into the extended object
        const thisMerge = function (obj) {
            for (let prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    // If deep merge and property is an object, merge properties
                    if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        extended[prop] = Http.extend(true, extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

// Loop through each object and conduct a merge
        for (; i < length; i++) {
            let obj = arguments[i];
            thisMerge(obj);
        }
        return extended;
    }

    static cancelToken() {
        return axios.CancelToken.source();
    }

    static nextQueueItem() {
        if (Http.queue_list.length) {
            let queue_item = Http.queue_list.shift();
            queue_item.callback(queue_item.resolve, queue_item.fail);
        }
    }

    static queue(config) {
        return new Promise((r, f) => {
            Http.queue_list.push({
                resolve: r,
                fail: f,
                callback: function (resolve, fail) {
                    Http.request(config).then(res => {
                        resolve(res);

                        Http.nextQueueItem();
                    }, err => {
                        fail(err);
                    });
                }
            });

            if (Http.queue_list.length === 1)
                Http.nextQueueItem();
        });
    }

    static fixUrl(link) {
        if (typeof link === 'string'
            || link instanceof String) {
            if (link.substring(0, 8) !== 'https://'
                && link.substring(0, 7) !== 'http://'
            ) {
                return url(link);
            }
        }
        return link;
    }

    static request(config) {
        return new Promise(async (resolve, reject) => {
            config.url = Http.fixUrl(config.url);

            let cacheKey = '';
            if (typeof config.cache === "undefined")
                config.cache = false;

            if (config.cache !== false) {
                // vamos montar um cacheKey!
                cacheKey = 'request_cache_' + (await sha256(JSON.stringify(config)));

                const cache = await getStoredValue(cacheKey);
                if (cache) {
                    console.info('XHR finished loading FROM CACHE: ' + config.method + '"' + config.url + '".');
                    resolve(cache);
                    return;
                }
            }

            if (config.abort ) {
                // vamos montar um cacheKey!
                if (Http.abortSignals[config.abort]) {
                    Http.abortSignals[config.abort].abort();
                    console.info('XHR aborted for new request' + config.method + '"' + config.url + '".');
                }
                Http.abortSignals[config.abort] = new AbortController;
                config.signal = Http.abortSignals[config.abort].signal;
            }

            axios.request(config).then(response => {
                if (config.abort ) {
                    delete Http.abortSignals[config.abort];
                }
                // Erro de proxy!
                if (typeof response.data === 'string' && response.data.indexOf('\x15\x03') === 0) {
                    if (typeof config.proxyRetry !== 'undefined' && config.proxyRetry === 5 ||
                        config.method !== 'get'
                    ) {
                        let error = response;
                        error.response = {
                            data: response.data,
                            status: 400,
                            statusText: 'Bad Request'
                        }
                        delete error.data;
                        delete error.status;
                        delete error.statusText;

                        if (config.url.indexOf('/hb/') === -1) {
                            Http.defaultError(error);
                        }
                        reject(error);
                        return;
                    }
                    console.log('Failed request by proxy error, trying to send a new one');

                    // vamos dar retry pelo menos 3x nesse caso de erro de proxy
                    setTimeout(() => {
                        if (typeof config.proxyRetry === 'undefined')
                            config.proxyRetry = 0;
                        config.proxyRetry++;
                        Http.request(config).then(res => {
                            if (cacheKey !== '') {
                                setStoredValue(cacheKey, res, config.cache === true ? 5 : config.cache);
                            }
                            resolve(res);
                        }).catch(err => {
                            reject(err);
                        });
                    }, Math.max(config.retryTimeout ? config.retryTimeout : 300, 300));

                    return;
                }

                if (config.cache !== false) {
                    setStoredValue( cacheKey, response, config.cache === true ? 5 : config.cache);
                }
                resolve(response);
            }).catch(error => {
                if (config.abort ) {
                    delete Http.abortSignals[config.abort];
                }
                let errorStatus = parseInt(error.response ? error.response.status : (error.request ? error.request.status : 0));

                if (window.User && !axios.isCancel(error) && [401, 419].indexOf(errorStatus) >= 0) {
                    if (!heartBeatOnLogin) {
                        heartBeatOnLogin = true;
                        Layout.blockUI({
                            message: `<div class="blockuiWarning">
                    <h2>` + _t('Attention') + `</h2>
                    <p>` + _t('It appears that you have logged out or we have lost your login session, if you wish to keep your work, please log in again with your login details.') + `</p>
                    <button class="btn btn-primary" onclick="recoverLogin()">` + _t('Login') + `</button>
                    <br />
                    <button class="btn btn-danger" onclick="window.location = window.location" style="margin-top: 10px">` + _t('Reload') + `</button></div>`
                        });

                        clearTimeout(heartBeatInterval);
                        if (!window['DISABLE_HEARTBEAT'])
                            heartBeatInterval = setTimeout(heartBeatCheck, 5000);
                    }
                }

                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx

                    if (config.retry && config.retry > 0 && !axios.isCancel(error) && [408, 502, 524, 503, 504].indexOf(parseInt(error.response.status)) >= 0) {
                        // vamos dar retry
                        setTimeout(() => {
                            config.retry--;
                            Http.request(config).then(res => {
                                if (config.cache !== false) {

                                    setStoredValue(cacheKey, res, config.cache === true ? 5 : config.cache );
                                }
                                resolve(res);
                            }).catch(err => {
                                reject(err);
                            });
                        }, Math.max(config.retryTimeout ? config.retryTimeout : 100, 100));
                    } else {
                        reject(error);
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // vamos dar retry

                    if (config.retry && config.retry > 0 && !axios.isCancel(error)) {
                        // vamos dar retry
                        setTimeout(() => {
                            config.retry--;
                            Http.request(config).then(res => {
                                if (config.cache !== false) {
                                    setStoredValue( cacheKey, res, config.cache === true ? 5 : config.cache);
                                }
                                resolve(res);
                            }).catch(err => {
                                reject(err);
                            });
                        }, Math.max(config.retryTimeout ? config.retryTimeout : 100, 100))
                    } else {
                        reject(error);
                    }
                } else {
                    // Something happened in setting up the request that triggered an Error
                    reject(error);
                }
            });


        });
    }

    static get(url, config = null) {
        return Http.request(Http.extend({
            method: 'get',
            url: url
        }, config));
    }

    static delete(url, config = null) {
        return Http.request(Http.extend({
            method: 'delete',
            url: url
        }, config));
    }

    static head(url, config = null) {
        return Http.request(Http.extend({
            method: 'delete',
            url: url
        }, config));
    }

    static options(url, config = null) {
        return Http.request(Http.extend({
            method: 'options',
            url: url
        }, config));
    }

    static post(url, data = null, config = null) {
        return Http.request(Http.extend({
            method: 'post',
            data: data,
            url: url
        }, config));
    }

    static put(url, data = null, config = null) {
        return Http.request(Http.extend({
            method: 'put',
            data: data,
            url: url
        }, config));
    }

    static patch(url, data = null, config = null) {
        return Http.request(Http.extend({
            method: 'patch',
            data: data,
            url: url
        }, config));
    }

    static all(requests) {
        return axios.all(requests);
    }

    static spread(callback) {
        return axios.spread(callback);
    }

    static pushHistory(title, url, track = true) {
        window.history.pushState({}, title, url);

        if (track)
            Http.track(url, title);
    }

    static async applyContentToPage(
        $target,
        isModal,
        $loaderContent,
        $targetParent,
        url,
        response,
        withAnimation = true,
        pushHistory = true) {
        if (typeof response.data === 'object') {
            response.data = Layout.responseToHtml(response.data);
        }

        if (response.data === '<script data-cfasync="false">window.location="/auth/login";</script>') {
            window.location = 'auth/login';
            return false;
        }

        let $onAfterLeave = Layout.onAfterLeave;
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });

        Layout.onBeforeLeave = [];
        Layout.onAfterLeave = [];

        let animating = () => {
            for (let callback of $onAfterLeave) {
                callback();
            }

            if (window.disposableCharts) {
                for(let $el of window.disposableCharts) {
                    if ($el.data('chart')) {
                        $el.data('chart').dispose();
                    }

                    if ($el.data('table')) {
                        $el.data('table').destroy();
                    }

                    if ($el.data('map')) {
                        $el.data('map').destroy();
                    }
                }
                window.disposableCharts = []
            }

            window.resizeCharts = []

            //if (!isModal)
            //    $('script:not(.preloaded)').remove();

            Layout.loader(false);
            if ($loaderContent)
                Layout.loaderContent($loaderContent, false);

            if (withAnimation)
                $($target).removeClass('fadeOut').addClass('animated fadeIn').html(response.data);
            else
                $($target).html(response.data);

            if (withAnimation) {
                setTimeout(function () {
                    $($target).removeClass('fadeIn')
                }, 1000);
            }

            Layout.bindEvents($target);
            Layout.evalScripts($target, $targetParent);

            if (!isModal && pushHistory) {
                Http.pushHistory(document.title, url, false);
            }
            Http.track(url, document.title);
        }


        if (withAnimation) {

            return new Promise((resolve) => {
                setTimeout(() => {
                    animating();
                    resolve(true);
                }, 700);
            });
        }
        animating();

        return true;
    }

    static async navigate(url, data = null, $target = null, method = 'get', withAnimation = true, $loaderContent = null, pushHistory = true, clearHooks = true) {
        LayoutHeader.closeSearch();
        tippy.hideAll();

        return new Promise(async (resolve, fail) => {

            url = Http.fixUrl(url);

            if (!url) {
                return false;
            }

            if ($target === null)
                $target = Layout.$Content;

            let isModal = $($target).parents('.modal:first').length > 0;
            let $targetParent = isModal ? $($target).parents('.modal:first') : $('#page');

            let callback, stopNavigation = false;
            for (callback of Layout.onBeforeLeave) {
                if (await callback() === true) {
                    stopNavigation = true;
                }
            }

            if (stopNavigation) {
                fail({error: 'cancel'});
                return false;
            }

            if (clearHooks)
                Layout.clearHooks();

            Layout.loader(true);

            if ($loaderContent === null)
                $loaderContent = $target.attr('id') === 'page-content' ? $target.parent() : $target;

            Layout.loaderContent($loaderContent, true);

            if (LayoutHeader && LayoutHeader.isOpen) {
                $('body').addClass('will-close');
            }
            Layout.closeSidebar();

            // TODO - Tem que colocar pra fechar sidebar!

            if ($target.is(Layout.$Content)) {
                $('[data-yield]').removeClass('has-content').html('');
            } else if (isModal) {
                $("[data-yield]", $targetParent).html('');
            }

            if (withAnimation)
                $($target).removeClass('fadeIn').addClass('fadeOut');

            Http.request({
                method,
                url,
                data
            }).then(async response => {

                if (response.status === 200) {
                    Http.pageId = new Date().getTime();

                    if (response.data.indexOf('Layout.showMenu') === -1) {
                        Layout.closeMenu();
                    }

                    await Http.applyContentToPage(
                        $target,
                        isModal,
                        $loaderContent,
                        $targetParent,
                        url,
                        response,
                        withAnimation,
                        pushHistory
                    );

                    resolve(response.data);
                } else {
                    fail(response);
                }
            }, async error => {
                Layout.loader(false);
                Layout.loaderContent($loaderContent, false);

                let errorStatus = parseInt(error.response ? error.response.status :

                    (error.request ? error.request.status : (error.code ? error.code : 0)));

                if ([403, 404, 503].indexOf(errorStatus) >= 0) {
                    let response = await Http.request({
                        method: 'GET',
                        url: 'error/' + errorStatus
                    });

                    await Http.applyContentToPage($target, isModal, $loaderContent, $targetParent, url, response, withAnimation, pushHistory);

                } else {

                    await new Promise(resolve => {
                        if (errorStatus !== 401) {
                            axios.defaultRequestError(error);
                        }

                        if (withAnimation) {
                            $($target).removeClass('fadeOut').addClass('animated fadeIn').html(error.response.data);
                            setTimeout(function () {
                                $($target).removeClass('fadeIn')

                                resolve(true);
                            }, 1000);
                        } else {
                            $($target).html(error.response.data);

                            resolve(true);
                        }
                    });
                }
                fail(error);
            });
        });
    }

    static track(url, title) {
        if (url instanceof Location) {
            url = url.href;
        }

        let t = url.replace('https://', '').split('/');
        t.shift();
        url = '/' + t.join('/');

        if (window.heap)
            heap.track('page_view', {url, title});

        if (window.woopra)
            woopra.track("pv", {url, title});

        if (typeof ga == 'function') {
            ga('send', {
                hitType: 'pageview',
                page: url,
                title: title
            });
        }
        if (typeof gtag == 'function') {
            gtag('event', 'page_view', {
                page_title:title,
                page_location: url,
                page_referrer: Http.lastUrl,
                //send_to: 'SIS'
            });
        }

        if (window.mixpanel) {
            mixpanel.track("Page View", url);
        }

        if (window.amplitude)
            amplitude.getInstance().logEvent("PageView", {path: url, title: title});

        Http.lastUrl = url;
    }

    static trackEvent(event, data) {

        if (typeof gtag == 'function') {
            gtag('event', event, data);
        }
    }
}

Http.lastUrl = window.location.href;
Http.pageId = new Date().getTime();
Http.queue_list = [];
Http.queue_idx = 0;
Http.cache = {};
Http.abortSignals = {};
Http.CancelToken = axios.CancelToken;
